import { render } from "./FirstSectionChild.vue?vue&type=template&id=48ad470e"
import script from "./FirstSectionChild.vue?vue&type=script&lang=js"
export * from "./FirstSectionChild.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__